import React, { useState } from "react";
import { Grid, Typography, Button, Switch } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles((theme) => ({
  inline: {
    fontSize: "1.5rem",
    display: "inline",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1rem",
    marginTop: "0.25rem",
  },
  hr: {
    border: "0.5px solid #000000de",
    marginTop: "3rem",
    marginBottom: "2rem",
    width: "100%",
    borderBottom: "thick",
  },
  textfieldWidth: {
    width: "80%",
    marginTop: "8px",
  },
  required: {
    color: "red",
    marginLeft: "4px",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    fontWeight: 600,
  },
    saveButton: {
    backgroundColor: "#EC6535",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#993d13",
    },
  },
  backButton: {
    backgroundColor: "#707070",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#4d4d4d",
    },
  },
}));

const OptionsAndPermissions = (props) => {
  const classes = useStyles();

  const {
    handleNext,
    handleBack,
    handleChangeOptionsAndPermissions,
    optionsAndPermissions,
  } = props;
  const { stepAuthenticated, azureAdSignIn, editPhoneNumber } =
    optionsAndPermissions;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="body2" className={classes.inline}>
            Options and Permissions (Default)
          </Typography>
          <hr className={classes.hrLine} />
        </Grid>
        <Grid item xs={10}>
          <Typography variant="subtitle1" className={classes.subtitle}>
            Should be 2-Step Authenticated
          </Typography>
          <Typography variant="body2" className={classes.description}>
            Authenticate the person using code sent to the person's device
            (phone number in this case).
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Switch
            checked={stepAuthenticated}
            onChange={handleChangeOptionsAndPermissions}
            name="stepAuthenticated"
            color="primary"
          />
        </Grid>

        <Grid item xs={10}>
          <Typography variant="subtitle1" className={classes.subtitle}>
            Cannot edit phone number
          </Typography>
          <Typography variant="body2" className={classes.description}>
            Don’t allow the user to edit their phone number. This requires you
            to enter the phone number.
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Switch
            checked={editPhoneNumber}
            onChange={handleChangeOptionsAndPermissions}
            name="editPhoneNumber"
            color="primary"
          />
        </Grid>

        <Grid item xs={10}>
          <Typography variant="subtitle1" className={classes.subtitle}>
            Use Ping Sign-In
          </Typography>
          <Typography variant="body2" className={classes.description}>
            Enable this option to use Ping credentials to verify the
            person.
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Switch
            checked={azureAdSignIn}
            onChange={handleChangeOptionsAndPermissions}
            name="azureAdSignIn"
            color="primary"
          />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "space-around",marginTop:"3rem" }}
        >
        <Grid
          className={classes.backButton}
          onClick={handleBack}
        >
          <ChevronLeftIcon />
          Back
        </Grid>
        <Grid
          className={classes.saveButton}
          onClick={handleNext}
        >
          Save & Next
          <ChevronRightIcon />
        </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default OptionsAndPermissions;
